/* Add Product in to cart from product grid */
$(".btnAddFromGrid").click( function(){
  console.log("X");
  var curr_obj = $(this);
  var curr_obj_form = curr_obj.parents("form");

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(curr_obj_form).serialize(),
    dataType: 'json',
    success: function(line_item) { 
      window.location.href = '/cart';
    },
    error: function(XMLHttpRequest, textStatus) {
      window.location.href = '/cart';
    }
  });
});
/* Add Product in to cart from product grid */

/* Fire quora event on prodyct page add to cart click */
$(".btn_addtobag_new").click( function(){
  qp('track', 'Purchase');
  console.log("quora click fire");
});


$('.pnp-media').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots:true
  });